import { createFileRoute } from '@tanstack/react-router'

import { AdvisorConfigSection } from '@/components/Internal/GlobalConfig/AdvisorConfigSection'

export const Route = createFileRoute('/internal/system/settings/advisor')({
  component: AdvisorConfigSection,
})
